import RequestMain from 'apps/auth/components/history/request/RequestMain';
import { AUTH_VIEW } from 'apps/auth/constants/ServerConstants';
import RequestPage from 'apps/auth/pages/request/RequestPage';
import RequestPayPage from 'apps/auth/pages/request/RequestPayPage';

const authRequest = [
    {
        path: '/auth/request/create',
        component: RequestPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            initRequest: true,
            isCreate: true,
            innerPage: true,
        },
    },
    {
        path: '/auth/request/pay/:billId',
        component: RequestPayPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            initRequest: true,
            isPay: true,
            innerPage: true,
        },
    },
    {
        path: '/auth/request/main.page',
        component: RequestMain,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            isChatBottomUp: true,
        },
    },
];

export default authRequest;
